import { ReactElement } from 'react';
import styled from 'styled-components';

import { Flex, Section, Typography } from 'components';
import { Icon } from 'components/icon';
import { useProducts } from 'features/products';
import { useModules } from 'features/modules';
import { useSchool } from 'features/school';

const HeaderOverlay = styled(Flex)`
  width: 100%;
  height: 100%;
  background: url('/images/headerOverlay.png');
  position: absolute;
  background-size: cover;
  top: 0;
  left: 0;
`;

const EventIcon = styled(Icon)`
  width: 24px;
`;

const EventsHeader = (): ReactElement => {
  const { productDetails } = useProducts();

  const { schoolAlias } = useSchool();

  return productDetails ? (
    <>
      <Flex
        flexGrow={0}
        minHeight={{ m: 240, t: 360, d: 500 }}
        bg={schoolAlias === 'b3' ? 'dark_350' : 'primary_400'}
        backgroundImage={productDetails.product.coverImageUrl ? `url(${productDetails.product.coverImageUrl})` : undefined}
        backgroundSize="cover"
        position="relative"
      >
        <HeaderOverlay alignItems="center">
          <Section position="relative" alignItems="center">
            <Flex position="relative" flexGrow={0} flexDirection="column" maxWidth={{ d: 500 }}>
              <Flex alignItems="center">
                <EventIcon icon="radiotower" />
                <Typography type="type2" fontWeight="bold" color="white" upper ml={2}>
                  {productDetails.product.hat}
                </Typography>
              </Flex>

              <Typography as="h1" type="type9" fontWeight="bold" color="white" mt={{ m: '10px', t: 15 }}>
                {productDetails.product.name}
              </Typography>
              <Typography type="type3" fontWeight="bold" color="white" upper mt={{ m: '10px', t: 15 }}>
                23 a 25 de setembro
              </Typography>

              <Typography type="type0" color="white" upper mt={{ m: '10px', t: 15 }}>
                online via zoom
              </Typography>

              <Typography type="type1" fontWeight="bold" color="white" mt={{ m: '10px', t: 15 }}>
                Participe do maior evento online sobre análise setorial com especialistas e convidados exclusivos da MELVER
              </Typography>
            </Flex>
          </Section>
        </HeaderOverlay>
      </Flex>
    </>
  ) : (
    <></>
  );
};
export default EventsHeader;
